// Sidebar fija con marca, navegación (estado activo) y pie. Markup y clases
// idénticos al frontend original; navegación con TanStack Router <Link>.
import { Link } from '@tanstack/react-router';
import { NAV } from '../lib/nav';

export function Sidebar({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <aside className="sidebar">
      <div className="brand">
        <span className="logo"><i className="fa-solid fa-cube" /></span>
        <span className="brand-text">
          <b>Inventario</b>
          <span>GESTIÓN &amp; BODEGAS</span>
        </span>
      </div>

      <nav className="nav">
        {NAV.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className="nav-item"
            activeOptions={{ exact: item.path === '/' }}
            activeProps={{ className: 'nav-item active' }}
            onClick={onNavigate}
          >
            <i className={`fa-solid ${item.icon}`} />
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>
    </aside>
  );
}
